import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

export function Layout() {
  return (
    <div className="shell">
      <TopBar />
      <div className="shell__body">
        <Sidebar />
        <main className="shell__main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
